// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".phone-number-field label.control-label{margin-bottom:4px}.phone-number-field .error-block{color:#d0021b;font-size:14px;line-height:1.2em;margin-left:12px;margin-top:5px;min-height:1.2em}", ""]);
// Exports
module.exports = exports;
